import { renderRadioGroup } from './chunk-KRJ7Q224.js';
import { ClassManager } from './chunk-KDDYW2ND.js';
import { RadioGroup } from './chunk-DTUJSI3R.js';
import { Radio } from './chunk-KA7XIFKH.js';
import { MenuItems } from './chunk-QJJ5OGI7.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_create_walker, $$_insert_at_marker_lite, $$_create_template } from 'maverick.js/dom';
import { effect } from 'maverick.js';
import { defineElement } from 'maverick.js/element';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><span><!$></span>`);
var $$_templ_2 = $$_templ;
var QualityMenuItems = class extends MenuItems {
  constructor(instance) {
    super(instance);
    this.a = useMedia();
  }
  onConnect(el) {
    effect(this.ra.bind(this));
    effect(this.sa.bind(this));
    const { radioClass, radioCheckClass } = this.$props;
    new ClassManager(el).t("media-radio", radioClass).t('[part="check"]', radioCheckClass);
  }
  sa() {
    const { autoLabel } = this.$props;
    const { autoQuality, quality } = this.a.$store;
    this.z.ab.set(!autoQuality() && quality() ? quality().height + "p" : autoLabel());
  }
  ra() {
    const { qualities } = this.a.$store;
    this.z.pa(qualities().length === 0);
  }
  q() {
    const { canSetQuality, qualities } = this.a.$store;
    return !canSetQuality() || qualities().length === 0;
  }
  o(event) {
    if (this.q())
      return;
    const radioGroup = event.target;
    if (radioGroup.value === "auto") {
      this.a.remote.changeQuality(-1, event);
      return;
    }
    const value = +radioGroup.value, index = this.a.qualities.toArray().findIndex((quality) => quality.height === value);
    if (index >= 0)
      this.a.remote.changeQuality(index, event);
  }
  Z() {
    const { quality, autoQuality } = this.a.$store;
    return autoQuality() ? "auto" : (quality()?.height ?? "auto") + "";
  }
  _() {
    const { autoLabel } = this.$props, { qualities } = this.a.$store;
    return [
      { value: "auto", content: () => (() => {
        const [$$_root, $$_walker] = $$_create_walker($$_templ), $$_expr = $$_walker.nextNode();
        $$_insert_at_marker_lite($$_expr, autoLabel);
        return $$_root;
      })() },
      ...qualities().sort((a, b) => b.height - a.height).map((quality) => ({
        value: quality.height + "",
        content: () => (() => {
          const [$$_root, $$_walker] = $$_create_walker($$_templ_2), $$_expr = $$_walker.nextNode();
          $$_insert_at_marker_lite($$_expr, quality.height + "p");
          return $$_root;
        })()
      }))
    ];
  }
  render() {
    const { radioGroupClass } = this.$props;
    return renderRadioGroup({
      value: this.Z.bind(this),
      options: this._.bind(this),
      radioGroupClass,
      onChange: this.o.bind(this)
    });
  }
};
QualityMenuItems.el = defineElement({
  tagName: "media-quality-menu-items",
  props: {
    autoLabel: "Auto",
    radioGroupClass: null,
    radioClass: null,
    radioCheckClass: null
  }
});
QualityMenuItems.register = [RadioGroup, Radio];

export { QualityMenuItems };
